import styled from 'styled-components'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ConfigurationCheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
`
